/**
 * @generated SignedSource<<4e8da2e4daf9cfeb7d9a369cbe13c06d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type BuildPersonalChangeCommentQuery$variables = {
  changeLocator: string;
};
export type BuildPersonalChangeCommentQuery$data = {
  readonly change: {
    readonly comment: string | null | undefined;
  } | null | undefined;
};
export type BuildPersonalChangeCommentQuery = {
  response: BuildPersonalChangeCommentQuery$data;
  variables: BuildPersonalChangeCommentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "changeLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "changeLocator",
    "variableName": "changeLocator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "comment",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildPersonalChangeCommentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Change",
        "kind": "LinkedField",
        "name": "change",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BuildPersonalChangeCommentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Change",
        "kind": "LinkedField",
        "name": "change",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "401c492bb2f1deb4a6a8f26b4750137a",
    "id": null,
    "metadata": {},
    "name": "BuildPersonalChangeCommentQuery",
    "operationKind": "query",
    "text": "query BuildPersonalChangeCommentQuery(\n  $changeLocator: String!\n) {\n  change(changeLocator: $changeLocator) {\n    comment\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c5ae3736f81d93edc7df44c1cb98b32f";

export default node;
